const MODAL_TYPE = {
    NEW_DAMAGE_REPORT: 'NEW_DAMAGE_REPORT',
    SAMPLING_MODIFICATION_MODAL: 'SAMPLING_MODIFICATION_MODAL',
    CONFIRM_MODAL: 'CONFIRM_MODAL',
    NONE: false,
};

// eslint-disable-next-line import/prefer-default-export
export { MODAL_TYPE };
